import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cdec99e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-container" }
const _hoisted_2 = { class: "warning" }

import {
    onBeforeUnmount,
    onMounted,
    onUnmounted,
    ref,
    computed,
    watch,
    inject
  } from 'vue'
  import {useRoute, useRouter} from 'vue-router'

  import {usePreloader} from '@/lib/preloader.js'

  import PreloadedVideo from '@/components/PreloadedVideo.vue'
  import VideoSubtitles from '@/components/VideoSubtitles.vue'
  import IconButton from '@/components/inputs/IconButton.vue'
  import ModalOverlay from '@/components/ModalOverlay.vue'
  import ButtonInput from '@/components/inputs/ButtonInput.vue'

  import {useStore} from 'vuex'
  import {t} from '@/lib/i18n.js'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'VideoView',
  emits: ['videoStart', 'videoEnd'],
  setup(__props, { emit }) {

  usePreloader()

  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const bus = inject('bus')

  const skipButton = ref(null)
  const isRTL = computed(() => document.body.classList.contains('rtl'))

  const title = route.meta.title

  const videoSource = route.meta.videoSource

  const video = ref(null)
  const subtitles = ref(null)
  const showSkip = ref(false)
  const showWarning = ref(false)

  const skipText = t(store, 'video.actions.skip')
  const cancelText = t(store, 'video.actions.cancel')
  const confirmText = t(store, 'video.actions.confirm')
  const warningText = t(store, 'video.warning.content')
  const warningTitleText = t(store, 'video.warning.title')

  

  let skipTimer = null

  function addVideoEventListeners() {
    video.value.video.addEventListener('timeupdate', onTimeUpdate)
    video.value.video.addEventListener('ended', onEnded)
  }

  function removeVideoEventListeners() {
    video.value.video.removeEventListener('timeupdate', onTimeUpdate)
    video.value.video.removeEventListener('ended', onEnded)
  }

  function onTimeUpdate() {
    subtitles.value.update(route.meta.subtitlesKey, video.value.video.currentTime)
  }

  function onSkipConfirm() {
    const videoState = store.getters.videoStatus
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - skip video',
        label: videoState
      }
    })
    onEnded(null)
  }

  function onEnded(e) {
    // if from video end, track
    if (e) {
      const videoState = store.getters.videoStatus
      bus.publish({
        event: 'TRACK',
        data: {
          action: '<location> - skip video',
          label: videoState
        }
      })
    }
    router.push(route.meta.nextRoute)
  }

  const onSkip = () => {
    showWarning.value = true
  }

  const onClose = () => {
    showWarning.value = false
  }

  const devMode = process.env.NODE_ENV === 'development'
  const skipTimeoutDuration = devMode ? 0 : 3000
  const muted = computed(() => store.state.muted)

  watch(muted, (value) => (video.value.video.muted = value))

  onMounted(() => {
    // update store to tell media & video

    // check if body has rtl class

    store.commit('updateTrackingData', {
      isMedia: true,
      mediaType: 'video',
      mediaKey: route.meta.subtitlesKey
    })

    if (route.meta.videoLoop) {
      video.value.video.loop = true
    }

    addVideoEventListeners()

    skipTimer = setTimeout(() => {
      showSkip.value = true
    }, skipTimeoutDuration)

    emit('videoStart')

    video.value.video.muted = muted.value

    const videoState = store.getters.videoStatus
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - play video',
        label: videoState
      }
    })
  })

  onBeforeUnmount(() => {
    removeVideoEventListeners()
    video.value.video.muted = false
  })

  onUnmounted(() => {
    if (skipTimer) {
      clearTimeout(skipTimer)
    }

    emit('videoEnd')

    store.commit('updateTrackingData', {
      isMedia: false,
      mediaType: null,
      mediaKey: null
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    key: _unref(title),
    class: "page-video"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PreloadedVideo, {
        ref_key: "video",
        ref: video,
        src: _unref(videoSource)
      }, null, 8, ["src"]),
      _createVNode(VideoSubtitles, {
        ref_key: "subtitles",
        ref: subtitles
      }, null, 512)
    ]),
    _createVNode(ModalOverlay, {
      active: showWarning.value,
      class: "skip-modal",
      onClose: onClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_unref(warningTitleText)), 1),
          _createTextVNode(" " + _toDisplayString(_unref(warningText)), 1)
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(IconButton, {
              name: "submit",
              onClick: onSkipConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(confirmText)), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(ButtonInput, {
              name: "close",
              priority: "secondary",
              onClick: onClose
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(cancelText)), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showSkip.value)
          ? (_openBlock(), _createBlock(IconButton, {
              key: 0,
              ref_key: "skipButton",
              ref: skipButton,
              name: "submit",
              class: _normalizeClass({'skip-button': true, 'header-button': true, rtl: _unref(isRTL)}),
              priority: "secondary",
              onClick: onSkip
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(skipText)), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})